// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cms-search.v-text-field--outlined fieldset {\n  border-width: 2px;\n}\n.cms-search.v-text-field--outlined.v-input--is-focused fieldset {\n  border-width: 3px;\n}\n.featured-card {\n  width: 400px;\n  margin-left: 15px;\n  margin-right: 15px;\n  margin-bottom: 15px;\n}", ""]);
// Exports
module.exports = exports;
